import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Table, { RowType } from "../Shared/CustomTable";
import RoleModal from "./RoleModal";
import { useRolesState, useRolesDispatch } from "store/hooks/roles";
import { RoleType } from "store/types";
import Loader from "../Shared/Loader";
import ConfirmationModal from "../Shared/Modals/ConfirmationModal";
import { CONFIRMATION_MODAL_CONFIG } from "../../config/constants";

const headers = [
  { content: "ROLE NAME", style: { width: "200px" }, class: "l-ll t-ll" },
  { content: "DATASETS", style: { width: "500px" }, class: "t-ll" },
  { content: "PERMISSIONS", style: { width: "352px" }, class: "t-ll" },
  { content: "", style: { width: "160px" }, class: "t-ll" },
];

const CustomerRoles = () => {
  const [modalShow, setModalShow] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState<RoleType | undefined>(
    undefined
  );

  const roles = useRolesState();
  const { getRoles, deleteRole } = useRolesDispatch();
  
  useEffect(() => {
    getRoles();
  }, []);

  const handleAddRole = () => {
    setSelectedRole(undefined);
    setModalShow(true);
  };

  const handleEditRole = (role: RoleType) => {
    setSelectedRole(role);
    setModalShow(true);
  };

  const handleDeleteRole = (role: RoleType) => {
    setSelectedRole(role);
    setShowConfirmationModal(true);
  };

  const handleClose = () => {
    setModalShow(false);
  };

  const rows: RowType[] = roles.map((role) => ({
    id: role._id!,
    columns: [
      { content: role.role, class: "l-ll t-ll" },
      { content: role.datasets.join(","), class: "t-ll" },
      {
        content: role.permissions,
        class: "t-ll",
        print: (permissions: string[]) => (
          <>
            <span>{`${permissions[0]} `}</span>
            {permissions.length > 1 && (
              <span className={"pill"}>{`${permissions.length - 1}`}+</span>
            )}
          </>
        ),
      },
      {
        style: { position: "relative", textAlign: "right" },
        class: "t-ll",
        content: (
          <>
            <Button className="btn-blue" onClick={() => handleEditRole(role)}>
              Edit
            </Button>
            <Button className="btn-gray" onClick={() => handleDeleteRole(role)}>
              Delete
            </Button>
          </>
        ),
      },
    ],
  }));

  return (
    <div className={"customer-b-01"}>
      <ConfirmationModal
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        modalConfig={CONFIRMATION_MODAL_CONFIG}
        modalContent={{
          headerContent: " ",
          bodyContent: "Are you sure you want to delete this role?",
          confirmContent: "Yes, delete role",
        }}
        confirmAction={() => deleteRole(selectedRole!._id)}
      />
      <RoleModal
        show={modalShow}
        onClose={handleClose}
        selectedRole={selectedRole}
      />
      <Loader forceScope={"CUSTOMERS_ROLES"}>
        <div className={"customer-title-players"}>
          <div className="title-b">
            Roles
            <button className="btn-blue" onClick={handleAddRole}>
              Add Role
            </button>
          </div>
          <Table
            classTable="users-customers-table table-with-borders"
            headers={headers}
            rows={rows}
            withoutScroll
            forceScope="CUSTOMERS_ROLES_TABLE"
          />
        </div>
      </Loader>
    </div>
  );
};

export default CustomerRoles;
